import { Component } from "react"
import PropTypes from "prop-types"
import Launcher from "./components/launcher"
import { connect } from "react-redux"
import { get } from "lodash"

class IntercomLauncher extends Component {
  state = {
    ready: false,
    pinned: false,
  }

  componentDidMount() {
    window.analytics.ready(() => {
      this.setState({ ready: true })
    })
  }

  toggleLauncherPin = () => {
    const { pinned } = this.state
    this.setState({ pinned: !pinned })
  }

  render() {
    const { disableIntercom } = this.props
    const { pinned, ready } = this.state
    return ready && !disableIntercom
      ? <Launcher pinned={pinned} toggleLauncherPin={this.toggleLauncherPin} />
      : <div />
  }
}

IntercomLauncher.propTypes = {
  disableIntercom: PropTypes.bool,
}

export default connect((state) => ({
  disableIntercom: get(state, "global.selected.accountMeta.disableIntercom", false),
}))(IntercomLauncher)
